import { gql } from 'graphql-request';

export default gql`
  query SiteMapForXML($hostname: String) {
    site(hostname: $hostname) {
      siteName
      hostname
      pages {
        url
        lastPublishedAt
      }
    }
  }
`;
